import { render, staticRenderFns } from "./GetBoardedOfficeLocation.vue?vue&type=template&id=585e34f9&scoped=true&"
import script from "./GetBoardedOfficeLocation.vue?vue&type=script&lang=js&"
export * from "./GetBoardedOfficeLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e34f9",
  null
  
)

export default component.exports